// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N0, N200A, N30A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var HeaderWrapper = styled.header(function (props) {
  return {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: props.spacing === 'comfortable' ? '24px 18px 18px 24px' : '24px 8px 18px 8px'
  };
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var StickyHeader = styled.header(function (props) {
  return {
    position: 'sticky',
    zIndex: 8,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat(props.top || 0, "px"),
    display: 'flex',
    alignItems: 'center',
    borderBottom: "2px solid ".concat("var(--ds-border, ".concat(N30A, ")")),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: props.spacing === 'comfortable' ? '18px 16px 3px 16px' : '18px 8px 3px 8px',
    backgroundColor: "var(--ds-surface, ".concat(N0, ")")
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MarkAsReadWrapper = styled.div({
  marginLeft: "var(--ds-space-100, 8px)",
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  minHeight: '32px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var StickyHeaderText = styled.h1(function (props) {
  return props.mixin();
}, {
  textAlign: 'center',
  flexGrow: 1,
  marginTop: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var GroupingText = styled.p(function (props) {
  return props.mixin();
}, {
  flex: 1,
  textTransform: 'uppercase',
  color: "var(--ds-text-subtlest, ".concat(N200A, ")"),
  marginTop: 0,
  marginLeft: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var HeaderText = styled.h2(function (props) {
  return props.mixin();
}, {
  flexGrow: 1,
  marginTop: 0
});